import { useApiClient } from '@/api/ApiClient'
const { get2, post, del } = useApiClient()

/* 조회 */
export const fastSearch = async (params) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([key, value]) => value != 'null'), // null과 undefined 제외
  )

  let path = `/fast/manseForce/`
  const { data } = await get2(path, filteredParams)
  return data
}

/* 내 사주 전용 조회 (서버가 마스킹된 birth 대신 guestUserId 기반으로 풀어서 응답) */
export const fastSearchByMySaju = async (guestUserId, userName, lang = 'KOR') => {
  let path = `/fast/manseForce/`
  const { data } = await get2(path, { guestUserId, userName, lang })
  return data
}
/* 대운조회 */
export const yearMonth = async (params) => {
  /*
  const params = body ? new URLSearchParams(clarify(body)) : {};
  params.append('systemId', this.systemId);
  return axios.get(`${this.endpoint}/fast/yearMonth/`, { params }).then((response) => response.data);
  */
  let path = `/fast/yearMonth/`
  const { data } = await get2(path, params)
  return data
}

/* 사주 조회 이력 등록 (fire-and-forget 권장) */
export const postGuestUserHistory = async (body) => {
  const path = `/users/groupGuestUsers/history`
  const { data } = await post(path, body)
  return data
}

/* manseForce 파라미터/저장된 사주 객체에서 history 요청 바디 생성 */
export const buildGuestUserHistoryBody = (src = {}) => {
  const systemId = Number(import.meta.env.VITE_APP_SYSTEMID)
  const genderRaw = src.gender
  const gender =
    genderRaw === 'MEN' || genderRaw === 'WOMEN'
      ? genderRaw
      : genderRaw === 1 || genderRaw === '1'
        ? 'MEN'
        : genderRaw === 0 || genderRaw === '0'
          ? 'WOMEN'
          : undefined
  const body = {
    systemId,
    guestUserName: src.guestUserName ?? src.userName ?? '',
    gender,
    birth: src.birth,
    birthTime: src.birthTime,
    bornArea: src.bornArea ?? src.addressTxt ?? undefined,
    bornAreaId: src.bornAreaId != null ? String(src.bornAreaId) : undefined,
    isLeapYear: !!src.isLeapYear,
    isLuna: src.isLuna ?? !!src.isLunar,
    option1: !!src.option1,
    option2: src.option2 ?? false,
    option3: !!src.option3,
    option4: src.option4 == null ? true : !!src.option4,
  }
  if (src.option5 != null) body.option5 = src.option5
  return body
}

/* fire-and-forget으로 history 등록 */
export const logGuestUserHistory = (src) => {
  try {
    const body = buildGuestUserHistoryBody(src)
    postGuestUserHistory(body).catch((err) => {
      if (import.meta.env.VITE_APP_MODE === 'development') {
        console.warn('사주 이력 저장 실패', err)
      }
    })
  } catch (err) {
    if (import.meta.env.VITE_APP_MODE === 'development') {
      console.warn('사주 이력 바디 생성 실패', err)
    }
  }
}

/* 저장 */
export const userGroupSave = async (data) => {
  let path = `/users/groupGuestUsers`
  const response = await post(path, data)
  return response
}

/* 저장 */
export const userGroupSave2 = async (params, queryParams) => {
  let path = `/users/groupGuestUsers`
  if (queryParams) {
    const qs = new URLSearchParams(queryParams).toString()
    path += `?${qs}`
  }
  const data = await post(path, params)
  return data
}

//삭제
export const userGroupDel = async (params) => {
  let path = `/users/groupGuestUsers`
  const { data } = await del(path, params)
  return data
}
//그룹정보 조회
export const userGroups = async (params) => {
  let path = `/users/userGroups`
  const { data } = await get2(path, params)
  return data
}

//사주한글조회
export const sajuKor = async (params) => {
  let path = `/fast/sajuKor/`
  const { data } = await get2(path, params)
  return data
}

//지역검색
export const cities = async (params) => {
  let path = `/eoway/cities`
  const { data } = await get2(path, params)
  return data
}
